import { render, staticRenderFns } from "./BaixarDadosModal.vue?vue&type=template&id=8c6c07e6&scoped=true"
import script from "./BaixarDadosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaixarDadosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaixarDadosModal.vue?vue&type=style&index=0&id=8c6c07e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6c07e6",
  null
  
)

export default component.exports